import { environmentHttpClient } from "client/Api/httpClient";

export type ViewsVisibilityModel = {
	orderKind: SharePointSiteCollectionOrderKind;
	nodes: readonly ViewVisibilityNodeModel[];
};

export type ViewVisibilityNodeModel = {
	id: string;
	name: string;
	createdOn: string | null;
	isVisible: boolean;
	children: readonly ViewVisibilityNodeModel[];
};

export enum SharePointSiteCollectionOrderKind {
	Custom = 0,
	NameAscending = 1,
	NameDescending = 2,
	CreatedOnAscending = 3,
	CreatedOnDescending = 4
}

export type SaveViewsVisibilityModel = {
	hiddenLibrariesIds: readonly string[];
	rootSiteIdOrder: readonly string[];
	orderKind: SharePointSiteCollectionOrderKind;
};

const controllerRelativeUrl = "Documents/SharePoint/DocumentViewStructureCustomization";

export function getVisibilitySettings(signal?: AbortSignal): Promise<ViewsVisibilityModel> {
	return environmentHttpClient.get<ViewsVisibilityModel>(
		controllerRelativeUrl + "/Data",
		undefined,
		{ signal }
	);
}

export function saveViewsVisibility(
	saveModel: SaveViewsVisibilityModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		controllerRelativeUrl + "/Save",
		saveModel,
		{ signal }
	);
}
